export default function({ state, commit, dispatch, rootState }, surveyObj) {
    commit('startSurvey', surveyObj.ref_id)
    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : surveyObj.provider) + '/patient/' + surveyObj.patient + '/survey',
        data: surveyObj
    }, {
        root: true
    })
    .then((survey) => {
        console.log(survey)
        if(survey && Array.isArray(survey.message) && survey.message.length > 0)
            dispatch('loadDataById', {...surveyObj, event: survey.message[0].response})
        
        commit('updatePatient', {
            id: surveyObj.patient,
            survey: [{
                id: survey.survey,
                created: new Date().getTime(),
                provider: surveyObj.provider + ':survey',
                event: surveyObj.ref_id,
                url: survey.url
            }]
        })

        commit('finishSurvey', surveyObj.ref_id)
        return survey.url
    })
    .catch((error) => {
      console.log(error)
      commit('finishSurvey', surveyObj.ref_id)
      throw error
    })
}
